import React, { useEffect, useState } from 'react';

import { observer } from 'mobx-react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

import classes from './NgzEntityAccountIssueInfo.module.scss';
import { loggedInUserDataStore } from '../../stores/loggedInUserDataStore';
import { angularizeWithProviders } from '../../providers';
import {
  corporateUsersService,
  GetNumberOfCorporateUsersResponse,
} from '../../services/corporateUsersService';

// used for old flow, delete when old flow entity will not exist
const NgzEntityAccountIssueInfo = observer(() => {
  const [corporateAccountsInfo, setCorporateAccountsInfo] = useState<
    GetNumberOfCorporateUsersResponse['corporateAccounts'] | null
  >(null);
  const { loggedInUser, isEntity, paymentFlowType } = loggedInUserDataStore;

  const isSubscriptionNotActive = !loggedInUser?.entity?.activeSubscription;

  const getCorporateAccountsInfo = async () => {
    const { corporateAccounts } = await corporateUsersService.getNumberOfCorporateUsers();

    setCorporateAccountsInfo(corporateAccounts);
  };

  useEffect(() => {
    if (isEntity && paymentFlowType.OLD) {
      getCorporateAccountsInfo();
    }
  }, [loggedInUser]);

  const isShowEntityAccountIssueInfo =
    isEntity && isSubscriptionNotActive && corporateAccountsInfo?.used;

  if (!isShowEntityAccountIssueInfo) {
    return null;
  }

  return (
    <div className={classes.errorMessage}>
      <WarningAmberRoundedIcon fontSize="medium" />
      <p>
        There is an issue with your Account. Your Entity Subscription Plan or credit card
        has expired. Your clients can&apos;t access the Platform. Please update your
        payment information or contact your Super Admin to resolve the issue.
      </p>
      <a href="#!/entity-profile" className={classes.link}>
        <EditRoundedIcon fontSize="medium" />
        <span>Fix Issue</span>
      </a>
    </div>
  );
});

angularizeWithProviders(NgzEntityAccountIssueInfo, 'ngzEntityAccountIssueInfo', {});

export { NgzEntityAccountIssueInfo };
